// extracted by mini-css-extract-plugin
export default {"shareButton":"ShareCharacterButton_shareButton__q-Zwy"};